export default __webpack_public_path__ + "static/media/fig57.f58d6832.png";